export default __webpack_public_path__ + "static/media/CBANQUE.0bd481dd.png";